import { AxiosRequestConfig, AxiosResponse } from "axios";
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { axiosInst, useSwr } from "./axiosHVS";

/* eslint-disable camelcase */
export interface UserPolicyEntity {
  expired: boolean;
  name: string;
  operations: string[];
  /* "62e3d4f382250e9859e8315f_create",
        "62e3d4f382250e9859e8315f_read_coc",
        "62e3d4f382250e9859e8315f_read_media",
        "62e3d4f382250e9859e8315f_update",
        "62e3d4f382250e9859e8315f_read_notes",
        "62e3d4f382250e9859e8315f_update_notes",
        "62e3d4f382250e9859e8315f_manage_permission",
        "62e3d4f382250e9859e8315f_enable",
        "62e3d4f382250e9859e8315f_read",
        "62e3d4f382250e9859e8315f_insertupdate",
        "62e3d4f382250e9859e8315f_delete"
      ], */
  type: string; // "entity_type",
  type_id: string; // "62e3d4f382250e9859e8315f"
}
export enum ModulePolicyTypes {
  // Module core
  workflowAdmin = "workflow_admin",
  usergroupsAdmin = "usergroups_admin",
  entitytypesAdmin = "entitytypes_admin",
  auditAdmin = "audit_admin",
  notificationAdmin = "notification_admin",
  domainsAdmin = "domains_admin",
  // Module Map
  timeline = "timeline",
  search = "search",
  mapView = "map_view",
  // Module DEM
  uploadMedia = "uploadMedia",

  // Module Pentaho
  advancedReport = "advanced_report",
  // Module Incident
  incident = "incident",
  sop = "sop",
}
export enum ModuleNames {
  core = "core",
  dem = "dem",
  pca = "pca",
  pentaho = "pentaho",
  map = "map",
  mobile = "mobile",
  incidentManagement = "incident_management",
}
export enum UserPolicyTypes {
  enable = "enable",
  read = "read",
  insertupdate = "insertupdate",
  delete = "delete",
  // camera
  play_live = "play_live",
  playback_operation = "playback_operation",
  export = "export",
  move_ptz = "move_ptz",
  move_preset = "move_preset",
  move_tour = "move_tour",
  audio = "audio",
  preset_management = "preset_management",
  // incident
  read_sop = "read_sop",
  update_sop = "update_sop",
  // gateway
  read_stats = "read_stats",
  reboot = "reboot",
  // case & evidence
  manage_permission = "manage_permission",
  create = "create",
  update = "update",
  read_coc = "read_coc",
  read_notes = "read_notes",
  update_notes = "update_notes",
  add_evidence = "add_evidence",
}

export const useUserPolicySettings = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<UserPolicyEntity>> => {
  const baseusersettings = `me/introspect`;
  return useSwr<ApiArrayResponse<UserPolicyEntity>>(
    `${baseusersettings}`,
    config
  );
};

export const getUserPolicySettings = async (
  config?: AxiosRequestConfig
): Promise<AxiosResponse<ApiArrayResponse<UserPolicyEntity>>> => {
  const baseusersettings = `me/introspect`;
  const data = axiosInst.get<ApiArrayResponse<UserPolicyEntity>>(
    `${baseusersettings}`,
    config
  );
  return data;
};
